import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.28195 1.32584C2.25648 1.82194 1.55422 2.83318 1.55422 4C1.55422 5.65685 2.9702 7 4.71689 7C5.08653 7 5.44071 6.94016 5.76976 6.83004C4.19569 5.96575 3.13556 4.35123 3.13556 2.5C3.13556 2.09599 3.18625 1.70272 3.28195 1.32584ZM3.78243 0.0985552C1.9032 0.501838 0.5 2.09548 0.5 4C0.5 6.20914 2.38797 8 4.71689 8C5.70557 8 6.61478 7.67725 7.33381 7.13677C7.66237 6.88981 7.46682 6.42066 7.06923 6.29463C5.39588 5.76419 4.18978 4.2657 4.18978 2.5C4.18978 1.97237 4.29748 1.4686 4.49316 1.00739C4.49767 0.996766 4.50222 0.986166 4.50682 0.975587C4.56865 0.833419 4.63887 0.69537 4.71689 0.561997C4.76678 0.47672 4.81985 0.393354 4.87597 0.312044C4.96642 0.180975 4.88204 0 4.71689 0C4.60766 0 4.49939 0.00393967 4.39225 0.0116774C4.21395 0.0245543 4.03874 0.0479502 3.86732 0.0812114C3.83892 0.0867226 3.81062 0.0925052 3.78243 0.0985552Z",
		fill: "currentColor"
	})
});
export default SvgMoon;
